import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPizzaSlice = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M22.5,14.5,3.7,22.38a1.58,1.58,0,0,1-.61.12h0A1.59,1.59,0,0,1,1.5,20.91h0a1.58,1.58,0,0,1,.12-.61L9.5,1.5a13,13,0,0,1,13,13Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M8.31,4.63A13,13,0,0,1,19.37,15.69"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 8.5,
			cy: 9.55,
			r: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M6.53,21.17a2,2,0,1,1,3-1.72,1.77,1.77,0,0,1-.1.61"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 14.5,
			cy: 15.45,
			r: 2
		})
	]
});
const ForwardRef = forwardRef(SvgPizzaSlice);
export default ForwardRef;
